import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

function* get() {
    try {
        const { id } = yield select((state) => state.userOrganisations.item);
        const url = `${config.api.paths.financeTypesList}?organisation=${id}`;
        const { data } = yield call(http.authorized.get, url);
        yield put(actionCreators.getSuccess(data));
    } catch (error) {
        logToSentry("On finance types get:", { error });
        yield put(actionCreators.getFailure(error));
    }
}

function* patch(action) {
    const { financeType } = action.payload;
    const { id } = yield select((state) => state.userOrganisations.item);
    const url = `${config.api.paths.financeTypes}${financeType.id}/?organisation=${id}`;
    try {
        const { data } = yield call(http.authorized.patch, url, financeType);
        yield put(actionCreators.patchSuccess(data));
    } catch (error) {
        logToSentry("On finance type patch:", { error });
        yield put(actionCreators.patchFailure(error));
    }
}

function* post(action) {
    const { financeTypes } = action.payload;
    const { userOrganisations } = yield select((state) => state);
    const url = config.api.paths.financeTypes;
    try {
        const { data } = yield call(
            http.authorized.post,
            url,
            financeTypes.map((item) => ({
                ...item,
                organisation: userOrganisations.item.id
            }))
        );
        yield put(actionCreators.postSuccess(data));
    } catch (error) {
        console.error(error);
        logToSentry("On finance types post:", { error });
        yield put(actionCreators.postFailure(error));
    }
}

export default function* () {
    yield all([
        takeLatest(actionTypes.FINANCE_TYPES_GET_REQUEST, get),
        takeLatest(actionTypes.FINANCE_TYPE_PATCH_REQUEST, patch),
        takeLatest(actionTypes.FINANCE_TYPES_POST_REQUEST, post)
    ]);
}
